import { dialogueErrorBody, getErrorBodyOpenFormApiError } from 'sos-eservice-common/js/config';

export function getDialogueByResponse(logId: string): dialogueErrorBody {
    const errorBody = getErrorBodyOpenFormApiError(logId);
    return errorBody;
}
